import { PaymentInfo } from '@/@types/generated/graphql'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'

type PaymentInfoDisplayProps = Omit<PaymentInfo, 'autoConfirm' | '__typename'>

const getCardBrandIcon = (brand?: string) => {
  switch (brand?.toLowerCase()) {
    case 'visa':
      return <span className="text-sm">💳</span>
    case 'mastercard':
      return <span className="text-sm">💳</span>
    case 'amex':
      return <span className="text-sm">💳</span>
    default:
      return <span className="text-sm">💳</span>
  }
}

export const PaymentInfoDisplay = ({
  type,
  endNum,
  month,
  year,
}: PaymentInfoDisplayProps) => {
  return (
    <Card
      variant="outlined"
      sx={{ display: 'flex', alignItems: 'center', p: 2 }}
    >
      {type != undefined && <Box sx={{ mr: 2 }}>{getCardBrandIcon(type)}</Box>}
      <CardContent sx={{ p: 0, paddingBottom: '0 !important' }}>
        <Typography variant="subtitle1" fontWeight="bold">
          {type?.toUpperCase() || 'CARD'} **** {endNum}
        </Typography>
        <Typography
          color="text.secondary"
          sx={{ paddingBottom: '0 !important' }}
        >
          Expires {String(month).padStart(2, '0')}/{year}
        </Typography>
      </CardContent>
    </Card>
  )
}
